import { Data, Cache } from "@gaming/srvg-classes-core";
import { CompetitionModel } from "../Model/CompetitionModel";
import { CompetitionStageModel } from "../Model/CompetitionStageModel";
import { PhaseModel } from "../Model/PhaseModel";
import { ChunkModel } from "../Model/ChunkModel";
import { ChunkRangeModel } from "../Model/ChunkRangeModel";

export class Timeline extends Data {
    /**
     * Stores the current competition
     */
    currentCompetitionModel: CompetitionModel;
    /**
     * Stores the current competition stage
     */
    currentCompetitionStageModel: CompetitionStageModel;
    /**
     * Model that stores the current chunk
     */
    currentChunkModel: ChunkModel;
    /**
     * Model that stores the current phase for the current channel
     */
    currentPhaseModel: PhaseModel;
    /**
     * Number that represents the currently selected channel
     */
    currentChannel: number;
    /**
     * Model that stores the current range of chunks
     */
    chunkRangeModel: ChunkRangeModel;

    /**
     * Stores known match objects. This way we don't have to create
     * new objects if we already created them once.
     */
    matchesCache:Cache;
    /**
     * Stores known matchset objects. This way we don't have to create
     * new objects if we already created them once.
     */
    matchsetsCache:Cache;
    /**
     * Stores known competitionstage objects. This way we don't have to create
     * new objects if we already created them once.
     */
    competitionStageCache:Cache;
    /**
     * Stores known competition objects. This way we don't have to create
     * new objects if we already created them once.
     */
    competitionCache:Cache;

    constructor() {
        super();

        this.currentCompetitionModel = new CompetitionModel();
        this.currentCompetitionStageModel = new CompetitionStageModel();
        this.currentChunkModel = new ChunkModel();
        this.currentPhaseModel = new PhaseModel();
        this.chunkRangeModel = new ChunkRangeModel();
        this.currentChannel = 0;

        var maxCompetitions = 4;
        var maxCompetitionstages = maxCompetitions*2;
        var maxMatchsets = 7*maxCompetitions;
        var maxMatches = maxMatches*4;
        var maxAge = maxCompetitions*70*60;

        this.matchesCache = new Cache( { maxAge: maxAge, maxSize: maxMatches } );
        this.matchsetsCache = new Cache( { maxAge: maxAge, maxSize: maxMatchsets } );
        this.competitionStageCache = new Cache( { maxAge: maxAge, maxSize: maxCompetitionstages } );
        this.competitionCache = new Cache( { maxAge: maxAge, maxSize: maxCompetitions } );
    }

    getGeneralPhaseName(phase_value){
        for (var phase_name in srvg.timelinePhases) {
            if ( srvg.timelinePhases[phase_name] && srvg.timelinePhases[phase_name].id===phase_value ) {
                return phase_name;
            }
        }
        console.log( 'General phase name for phase ' + phase_value + ' not found' )
        return phase_value;
    }

    destroy() {
        this.currentCompetitionModel = null;
        this.currentCompetitionStageModel = null;
        this.currentChunkModel = null;
        this.currentPhaseModel = null;
        this.chunkRangeModel = null;

        this.matchesCache.destroy();
        this.matchesCache = null;
        this.matchsetsCache.destroy();
        this.matchsetsCache = null;
        this.competitionStageCache.destroy();
        this.competitionStageCache = null;
        this.competitionCache.destroy();
        this.competitionCache = null;
    }
}